import { Modal, Button } from 'react-bootstrap';
import React from 'react';

import { logout } from "store/auth";
import useRouter from "util/useRouter";

import './styles.css';

const LogoutModal = (props) => {
  const { show, hide } = props;
  const { history } = useRouter();

  return (
    <Modal className="LogoutModal" show={show} onHide={hide}>
      <Modal.Header>
        Deseja mesmo sair?
      </Modal.Header>
      <Modal.Body className="LogoutModal_Body">
        <Button className="LogoutModal_Sair" onClick={() => {
          logout();
          history.push("/logout");
        }}>
          Sim
        </Button>
        <Button className="LogoutModal_Ficar" variant="secondary" onClick={() => {
          hide()
        }}>
          Não
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default LogoutModal;